var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '../../lib/dom';
import { formatCoins } from '../../lib/utils/string';
import { coinsById } from '../../../backend/src/utils/coinsById';
import './StoreProduct.less';
var StoreProduct = /** @class */ (function (_super) {
    __extends(StoreProduct, _super);
    function StoreProduct(props) {
        var _this = _super.call(this, props) || this;
        _this.name = 'Product';
        var p = props.p, onBuy = props.onBuy;
        _this.el = _this.DIV({ className: "& &_".concat(p.id, " ").concat(FOR_VK ? '&_vk' : ''), onClickOnly: onBuy }, [
            _this.DIV('&__name', formatCoins(coinsById(p.id, FOR_VK, FOR_YANDEX))),
            _this.DIV({ className: '&__price Button btn' }, ["".concat(p.priceValue, " ").concat(p.priceCurrencyCode)]),
        ]);
        return _this;
    }
    return StoreProduct;
}(Component));
export { StoreProduct };
